import { z } from '@harvestiq/zod';

export const getCampaignsRequestQuerySchema = z.object({
  searchText: z.string().optional(),
});
export type GetCampaignsRequestQuery = z.infer<
  typeof getCampaignsRequestQuerySchema
>;
